import React from 'react';

import {injectIntl} from "react-intl";


class NotFound extends React.Component {


  render() {

    return (
        <div style={{marginTop: '20px', marginBottom: '100px'}}>

        Wow,   404 Not Found!

        </div>
    );
  }
}


export default injectIntl(NotFound)